import { createApp } from 'vue'
import App from './App.vue'
import router from './router'

import 'primevue/resources/themes/saga-blue/theme.css'       //tema
import 'primevue/resources/primevue.min.css'                 //core css
import 'primeflex/primeflex.css'                             //libreria de estilos
import 'primeicons/primeicons.css'                           //iconos
//import FontAwesomeIcon from "./assets/fontawesome-icons";
import './assets/styles/layout.scss'                         //estilos (sass)

import PrimeVue from 'primevue/config'

const app = createApp(App)
    .use(PrimeVue, {
        csp: {
            nonce: 'XGgwSTSvSsAlcY9rdYQIWg=='
        }
    })
.use(router)
//.component("fa", FontAwesomeIcon)

app.mount('#app')




